if (!customElements.get('moebe-pair-purchase')) {
  customElements.define('moebe-pair-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      const button = form.querySelector('button[type="submit"]');
      const select = form.querySelector('select');
      const message = this.querySelector('[role="status"]');
      const row = this.closest('.moebe-pair');
      if (select) {
        button.disabled = !select.value;
        select.addEventListener('change', () => {
          button.disabled = !select.value;
          message.textContent = '';
          const option = select.selectedOptions[0];
          if (!option || !option.value) return;
          row.querySelector('.moebe-pair__price').textContent = option.dataset.price;
          row.querySelectorAll('a').forEach(link => link.href = option.dataset.url);
          const image = row.querySelector('img');
          if (image && option.dataset.image) {
            image.removeAttribute('srcset');
            image.src = option.dataset.image;
          }
        });
      }
          if (select) {
            select.hidden = true;
            select.tabIndex = -1;
            const picker = document.createElement('div');
            picker.className = 'moebe-related-picker';
            const trigger = document.createElement('button');
            trigger.type = 'button';
            trigger.className = 'moebe-related-picker__trigger';
            trigger.setAttribute('aria-expanded', 'false');
            trigger.setAttribute('aria-haspopup', 'listbox');
            const label = form.querySelector('label');
            const pickerId = select.id + '-list';
            trigger.setAttribute('aria-controls', pickerId);
            if (label) {
              label.id = select.id + '-label';
              trigger.setAttribute('aria-labelledby', label.id + ' ' + pickerId + '-value');
              label.removeAttribute('for');
              label.addEventListener('click', () => trigger.focus());
            }
            const value = document.createElement('span');
            value.id = pickerId + '-value';
            value.textContent = select.selectedOptions[0]?.textContent || '';
            trigger.append(value);
            const arrow = new DOMParser().parseFromString('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 16" aria-hidden="true"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" fill="none" stroke="currentColor" stroke-width="2"/></svg>', 'image/svg+xml').documentElement;
            trigger.append(arrow);
            const options = document.createElement('div');
            options.className = 'moebe-related-picker__options';
            options.id = pickerId;
            options.setAttribute('role', 'listbox');
            options.setAttribute('aria-label', label?.textContent || '');
            options.hidden = true;
            const entries = [];
            const close = () => { options.hidden = true; trigger.setAttribute('aria-expanded', 'false'); };
            const open = () => {
              options.hidden = false;
              trigger.setAttribute('aria-expanded', 'true');
              const index = Math.max(0, entries.findIndex(entry => entry.dataset.value === select.value));
              entries[index]?.focus();
            };
            for (const option of select.options) {
              if (!option.value) continue;
              const entry = document.createElement('button');
              entry.type = 'button';
              entry.className = 'moebe-related-picker__option';
              entry.setAttribute('role', 'option');
              entry.setAttribute('aria-selected', String(select.value === option.value));
              entry.tabIndex = -1;
              entry.dataset.value = option.value;
              entry.textContent = option.textContent;
              entry.disabled = option.disabled;
              entry.addEventListener('click', () => {
                select.value = option.value;
                select.dispatchEvent(new Event('change', {bubbles: true}));
                value.textContent = option.textContent;
                entries.forEach(item => item.setAttribute('aria-selected', String(item === entry)));
                close();
                trigger.focus();
              });
              options.append(entry);
              if (!option.disabled) entries.push(entry);
            }
            trigger.addEventListener('click', () => options.hidden ? open() : close());
            trigger.addEventListener('keydown', event => {
              if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); open(); }
            });
            picker.addEventListener('keydown', event => {
              if (event.key === 'Escape') { event.preventDefault(); close(); trigger.focus(); }
              const index = entries.indexOf(document.activeElement);
              if (index < 0) return;
              let next;
              if (event.key === 'ArrowDown') next = (index + 1) % entries.length;
              if (event.key === 'ArrowUp') next = (index - 1 + entries.length) % entries.length;
              if (event.key === 'Home') next = 0;
              if (event.key === 'End') next = entries.length - 1;
              if (next !== undefined) { event.preventDefault(); entries[next]?.focus(); }
              if (event.key === 'Tab') { close(); trigger.focus(); }
            });
            picker.addEventListener('focusout', event => { if (!picker.contains(event.relatedTarget)) close(); });
            picker.append(trigger, options);
            select.after(picker);
          }

      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (this.busy || !form.reportValidity()) return;
        this.busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        message.textContent = '';
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) {
            throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          }
          window.MoebeCRO?.success('recommendations');
          message.textContent = this.dataset.added;
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            bubbles: true,
            detail: { product: result, addToCartBtn: button }
          }));
        } catch (error) {
          message.textContent = error instanceof TypeError ? this.dataset.error : (error.message || this.dataset.error);
        } finally {
          this.busy = false;
          button.disabled = select ? !select.value : false;
          button.removeAttribute('aria-busy');
        }
      });
    }
  });
}
